/*
  We need to preload all the chunks owing to possible long user sessions(using a particular tab between releases),
  to avoid `Oops, something went wrong` error that occurs when an old `root` chunk tries to load
  subsequent/child chunks but with old chunk hash.
  TODO: please remove once there is a better approach.
 */
const scheduler =
  window.requestIdleCallback ?? ((fn) => window.setTimeout(fn, 1000));

/**
 * we don't need to preload all the chunks for embedded dashboards.
 * An embedded dashboard loads all the needed chunks on the first load.
 */
const preloadChunks = !window.location.pathname.match(/^\/embedded\/dashboard/);

if (preloadChunks) {
  scheduler(() =>
    Promise.all([
      import('./gtm-init'),
      import('@/integrations/styling'),
      import('@/integrations/Notifications/GlobalErrorNotification'),
      import('@/integrations/Notifications/TrevorNotificationContainer'),
      import('@/integrations/Intercom/TrevorIntercomProvider'),
      import('@/store/StoreProvider'),
      import('@/routing/TrevorRouterProvider'),
      import('@/containers/TrevorApp'),
      import('@/views/DashboardList'),
      import('@/views/QueryBuilder'),
      import('@/views/QueryBuilder/GetStarted'),
      import('@/views/QueryBuilder/QueryContent'),
      import('@/views/Dashboard'),
      import('@/containers/DatasourcesPage'),
      import('@/pages/DatasourceAccessReview'),
      import('@/pages/DatasourceAccessRequest'),
      import('@/containers/TeamAccess'),
      import('@/components/er-diagram/MapContainer'),
      import('@/features/subscription/components/CancelSubscription'),
      import('@/views/Credits'),
      import('@/views/Billing'),
      import('@/containers/Settings'),
      import('@/views/SavedQueries'),
      import('@/components/credentials/EditCredentials'),
      import('@/views/SharedDashboard'),
      import('@/views/SharedSavedQuery'),
      import('@/components/configure/SelectTables_LEGACY'),
      import('@/containers/EntrypointModal'),
      import('@/containers/UserActionsHandler'),
      import('@/components/AppNavigation'),
      import('@/containers/PublicDatasetsAppPage'),
    ]),
  );
}
